import { api, apiJson, API_PATH_ADMIN } from './client.js'

const BASE = `${API_PATH_ADMIN}/graph-configs`

export async function listConfigs() {
  const res = await api(`${BASE}`)
  return res.json()
}

export async function getActiveConfig() {
  const res = await api(`${BASE}/active`)
  return res.json()
}

export async function createConfig(name) {
  const res = await api(`${BASE}`, {
    method: 'POST',
    body: JSON.stringify({ name }),
  })
  return res.json()
}

export async function cloneConfig(configId) {
  const res = await api(`${BASE}/${configId}/clone`, { method: 'POST' })
  return res.json()
}

export async function updateConfig(configId, data) {
  const res = await api(`${BASE}/${configId}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
  return res.json()
}

export async function activateConfig(configId) {
  return apiJson(`${BASE}/${configId}/activate`, { method: 'POST' }, 'Ошибка активации')
}

export async function deleteConfig(configId) {
  const res = await api(`${BASE}/${configId}`, { method: 'DELETE' })
  return res.json()
}

export async function validateConfig(configId) {
  const res = await api(`${BASE}/${configId}/validate`)
  return res.json()
}
